<template>
  <div>
    <v-app-bar v-model="bar" dark height="70" flat app>
      <v-app-bar-nav-icon @click="drawer = !drawer" />
      <v-toolbar-title class="display-1 font-weight-bold" @click="visitSite">
        LifeWith™
      </v-toolbar-title>

      <v-spacer></v-spacer>
      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn text v-on="on">
            <v-icon>mdi-account-circle</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item @click="logout">
            <v-list-item-title>Logout</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
    <v-navigation-drawer v-if="drawer" v-model="drawer" dark app>
      <v-row class="text-center">
        <v-col cols="12">
          <v-avatar color="white" size="100">
            <v-img v-if="user.picture" :src="user.picture"></v-img>
            <span class="display-1 font-weight-medium dark-text" v-else>
              {{ user.firstName.substring(0, 1) }}{{ user.lastName.substring(0, 1) }}
            </span>
          </v-avatar>
        </v-col>
        <v-col cols="12">
          <h3 class="subtitle-2 text-center white--text">
            {{ user.firstName }} {{ user.lastName }}
          </h3>
        </v-col>
      </v-row>

      <hr />

      <v-list nav class="py-0">
        <v-list-item
          v-for="item in items"
          :key="item.title"
          :to="{ name: item.route }"
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import firebase from "@/firebase";

export default {
  data() {
    return {
      bar: true,
      drawer: true,
      items: [
        { title: "Profiles", route: "profiles", icon: "mdi-account-multiple" },
        { title: "Resources", route: "resources", icon: "mdi-office-building" },
        { title: "Documents", route: "documents", icon: "mdi-folder-open" },
        { title: "Notes", route: "notes", icon: "mdi-pencil-box" },
        { title: "Achievements", route: "achievements", icon: "mdi-trophy" },
      ],
      showNav: {
        account: false,
        achievements: true,
        calendar: true,
        documents: true,
        embed: false,
        login: false,
        notes: true,
        passwordReset: false,
        profile: true,
        profiles: true,
        register: false,
        resources: true,
      },
    };
  },
  computed: {
    ...mapGetters({
      user: "users/getUser"
    })
  },
  methods: {
    ...mapActions({
      initUser: "users/initUser",
    }),
    goToRoute(route) {
      this.$router.push({ name: route });
      if (window.innerWidth < 960) {
        this.configNav({
          drawer: !this.drawer,
        });
      }
    },
    logout() {
      firebase.auth.signOut();
      this.$router.push({ name: "login" });
    },
    visitSite() {
      window.open("https://lifewithautism.org", "_blank");
    }
  },
  async mounted() {
    const route = this.$router.currentRoute.name;
    this.bar = this.showNav[route];
    this.drawer = this.showNav[route];
    await this.initUser();
  },
};
</script>

<style scoped>
hr {
  border: 0.25px solid #ddd;
  width: 100% !important;
}
.display-1:hover {
  cursor: pointer;
}
.lighten {
  background-color: rgba(255, 255, 255, 0.25)
}
</style>
